module.exports = __webpack_public_path__ + "b91c1d5681daf33af2bc2b7a231902d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/slideshow_10_mobile.jpg
// module id = 661
// module chunks = 0